import React from 'react';
import { getConfig } from '../services/configManager';

const Header: React.FC = () => {
  const handleLogoClick = () => {
    // Redirect to home page and clear all state
    window.location.href = '/';
  };
  const imgSrc = getConfig().ASSETS.HeadLogo ? getConfig().ASSETS.HeadLogo : 'head-logo.png';

  return (
    <header className="bg-white h-16 border-b border-border-light">
      <div className="h-full flex items-center justify-center">
        <button
          onClick={handleLogoClick}
          className="focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded"
          aria-label="Go to home page"
        >
          <img 
            src={getConfig().ASSETS.BASE_URL + '/' + imgSrc}
            alt="Scan to Pay Logo"
            className={`h-10 w-auto object-contain cursor-pointer hover:opacity-80 transition-opacity duration-200`}
          />
        </button>
      </div>
    </header>
  );
};

export default Header; 